export default "__VITE_ASSET__BvYK0eze__"